import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
  signal
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzModalComponent } from 'ng-zorro-antd/modal';
import { ReportSharedModule } from '../../../../routes/reporting/reports/_shared/report-shared.module';
import { SharedModule } from '@shared';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-premium-feature-modal',
  standalone: true,
  imports: [FormsModule, NzModalComponent, ReportSharedModule, SharedModule],
  templateUrl: './premium-feature-modal.component.html',
  styles: `
    .text-styles {
      padding: 15px;
      font-size: 13px;
    }
    .button {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PremiumFeatureModalComponent {
  isVisible = signal(true);
  company = input<any>(null);
  showAsText = input<boolean>(false);
  lockedFeatureTitle = input<string>('Quinny AI');
  lockedFeatureDescription = input<string>('offers powerful automation to help you work smarter and unlock more advanced capabilities. Gain access by upgrading your plan.');
  close = output();
  router = inject(Router);
  msg = inject(NzMessageService);
  onOk = output<void>();

  onCancel() {
    this.close.emit();
  }
}
